/**
 * aminos-media-accordion.js
 *
 * Custom play/pause toggle for the section's video element.
 * Event-delegated at document level. Capture-phase listeners for play/pause
 * since those events don't bubble.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.aminos-media-accordion__play');
    if (!btn) return;
    var mediaEl = btn.closest('.aminos-media-accordion__media');
    if (!mediaEl) return;
    var video = mediaEl.querySelector('video.aminos-media-accordion__player');
    if (!video) return;
    e.preventDefault();
    if (video.paused) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    } else {
      video.pause();
    }
  });

  document.addEventListener(
    'play',
    function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('aminos-media-accordion__player')) return;
      var mediaEl = video.closest('.aminos-media-accordion__media');
      var btn = mediaEl && mediaEl.querySelector('.aminos-media-accordion__play');
      if (mediaEl) mediaEl.classList.add('is-playing');
      if (btn) btn.setAttribute('aria-label', 'Pause video');
    },
    true
  );

  document.addEventListener(
    'pause',
    function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('aminos-media-accordion__player')) return;
      var mediaEl = video.closest('.aminos-media-accordion__media');
      var btn = mediaEl && mediaEl.querySelector('.aminos-media-accordion__play');
      if (mediaEl) mediaEl.classList.remove('is-playing');
      if (btn) btn.setAttribute('aria-label', 'Play video');
    },
    true
  );
})();
